module.exports = __webpack_public_path__ + "static/media/back-icon.79bb2c6d.svg";